import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';

const Reward = () => {



  return (
    <>
            <Header icon={"fa-solid fa-users fa-xl mx-2"}  label={"People Management/Reward"} />

      <main id="main" className="main">

        <section className="section ">
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <div className='card'>

                <div className='card-body'>

                  <div className='card-description'>
                    <p>
                    Rewarding employees with fair, competitive, and well-deserved incentives serves to foster a collective appreciation that encourages active dedication in various facets of our organisation, ultimately influencing the extent to which employees feel connected and committed
to our mission.
                    </p>
                  </div>

                  <div className='content-block'>

                    <div className='h-4 card-content-headers mb-2'>
                    REMSYS: Increase & Incentive Allocation
                    </div>
                    <p>Our organisation allocates annual increases and incentives to qualifying employees. An automated system, REMSYS, is used to enable a structured and proactive management of the Reward process, resulting in a more efficient Reward cycle and outcome</p>
                    
                    <p>
                    The system aims at improving the quality of final performance-based salary increases and incentives. The REMSYS solution covers a structured Reward process encompassing validations, allocations, and reward letters.
                    </p>
                    <div className='link-container'>
                      <a href=''>
                      Click here to access REMSYS
                      </a>
                    </div>
                  </div>

                  <div className='content-block'>

                    <div className='h-4 card-content-headers mb-2'>
                    Incentive Scheme Contracting
                    </div>
                    <p>
                    As part of our overall Reward value proposition, we adopt an annual Incentive Scheme Contracting process for eligible employees. The Incentive Scheme programme aims to reward key employees whose performance is critical towards the achievement of business objectives.
                    </p>
                    <div className='link-container'>
                      <a href=''>
                      Click here to access the Incentive Scheme Contracting system
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
export default Reward;
